import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services'
import apiEndpoints from '../../const/apiEndpoints'
import { QrCodeResponse } from './typings'

export const getQrCodeList = createAsyncThunk(
  'qrcode/list',
  async (pageNumber: number): Promise<QrCodeResponse> => {
    const payload = {
      pageNo: pageNumber,
      pageSize: 100,
      sortBy: 'createdAt',
      ascDesc: 'Desc',
      searchCriteria: {}
    }

    const response = await api.post(apiEndpoints.qrList, payload)

    return response?.data
  }
)

export const manageQrCode = createAsyncThunk(
  'qrcode/manageQrCode',
  async (payload: any): Promise<QrCodeResponse> => {
    const response = await api.put(apiEndpoints.assignQrCode, payload)

    return response?.data
  }
)
